export default {
  download: 'Download',
  sendUnlockDoenload: 'Enable Download',
  cancelUnlockDownload: 'Cancel',
  requestPhysicalAppointment: 'Request Showroom Appointment',
  requestDigitalAppointment: 'Book a Virtual Appointment',
  sendRequest: 'Send Request',
  login: 'Login',
}
